module.exports = __webpack_public_path__ + "img/pointer.a33d1b7d.png";